import { render, staticRenderFns } from "./zoomDetail.vue?vue&type=template&id=4c011fa2&"
import script from "./zoomDetail.vue?vue&type=script&lang=js&"
export * from "./zoomDetail.vue?vue&type=script&lang=js&"
import style0 from "./zoomDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports